import { render, staticRenderFns } from "./TablePatientSelect.template.vue?vue&type=template&id=37844995&scoped=true&"
var script = {}
import style0 from "./TablePatientSelect.template.vue?vue&type=style&index=0&id=37844995&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37844995",
  null
  
)

export default component.exports